import React from "react";
import styles from "./LegalPageContent.module.scss";
import NavFooter from "../NavFooter/NavFooter"

const LegalPageContent = ({ children }) => {
  return (
    <div className={styles.wrapper}>
      <aside className={styles.sidebar}>
          <NavFooter variant="sidebar"/>
      </aside>

      <main className={styles.content}>
        {children}
      </main>
    </div>
  );
};

export default LegalPageContent;